module.exports = __webpack_public_path__ + "static/bg-pattern-white-small-da983da84202a373540aa73efced644a.png";